export default __webpack_public_path__ + "static/media/whu.a7c04b8b.svg";